export type FmtValues = Record<string, string | number | null | undefined>

/**
 * Fills {placeholders} in a text:
 *   fmt(t.timestamps.list.openCount, { count: 3 })   // "{count} offen" -> "3 offen"
 * A placeholder without a value stays visible, so a forgotten value shows on screen.
 */
export function fmt(text: string, values: FmtValues): string {
    return text.replace(/\{(\w+)\}/g, (match, name: string) =>
        Object.prototype.hasOwnProperty.call(values, name) ? String(values[name] ?? '') : match
    )
}

/**
 * Text for a value known only at runtime (an enum, a status from the API):
 *   textOf(t.shared.common.sorting, filter.Sorting)   // 'ASC' -> 'aufsteigend'
 * Falls back to `fallback`, else to the value itself.
 */
export function textOf(map: object, key: string | number | null | undefined, fallback?: string): string {
    if (key !== null && key !== undefined) {
        const text = (map as Record<string, unknown>)[String(key)]
        if (typeof text === 'string') return text
    }
    return fallback ?? (key === null || key === undefined ? '' : String(key))
}
